import React from "react";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { slide1, slide2, slide3, slide4, slide5 } from "src/assets";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import { Box, CardMedia, IconButton, Stack, SvgIcon } from "@mui/material";

const steps = [slide1, slide2, slide3, slide4, slide5];

const OnboardingSlider = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      navigate(SMART_CHARGING_ROUTES.CONNECT_CONFIRM);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleToOcpp = () => {
    navigate(-1);
  };

  return (
    <Stack gap={5}>
      <Stack direction={"row"} alignItems={"center"}>
        <Box flex={1}>
          <IconButton
            sx={() => ({
              padding: 0,
              borderRadius: 2,
              display: activeStep === 0 ? "none" : undefined,
            })}
            onClick={handleBack}
          >
            <SvgIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.75 12.75C20.75 13.1642 20.4142 13.5 20 13.5L6.81066 13.5L12.2803 18.9697C12.5732 19.2626 12.5732 19.7374 12.2803 20.0303C11.9874 20.3232 11.5126 20.3232 11.2197 20.0303L4.46967 13.2803C4.17678 12.9874 4.17678 12.5126 4.46967 12.2197L11.2197 5.46967C11.5126 5.17678 11.9874 5.17678 12.2803 5.46967C12.5732 5.76256 12.5732 6.23744 12.2803 6.53033L6.81066 12L20 12C20.4142 12 20.75 12.3358 20.75 12.75Z"
                  fill={activeStep === 0 ? "gray" : "black"}
                />
              </svg>
            </SvgIcon>
          </IconButton>
        </Box>
        <Box>
          <Text
            text={"MENNEKES Konfiguration"}
            sx={(theme) => ({
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: "600",
              color: theme.palette.mainFont.primary,
            })}
          />
        </Box>
        <Box flex={1}></Box>
      </Stack>

      <Stack alignItems={{ xs: "center", sm: "start" }}>
        <Stack sx={{ width: { sm: "355px" } }}>
          <CardMedia
            component="img"
            alt="hemsLogo"
            sx={{
              objectFit: "contain",
            }}
            image={steps[activeStep]}
          />
        </Stack>
      </Stack>

      <Stack
        direction={"column"}
        alignItems={"center"}
        width={{ sm: "355px" }}
        gap={3}
      >
        <PrimaryButton
          fullWidth
          onClick={handleNext}
          text={
            activeStep === steps.length - 1
              ? "Konfiguration abschließen"
              : "Nächster Schritt"
          }
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "20px",
            color: theme.palette.mainFont.primary,
            border: "0.829px solid",
            borderColor: theme.palette.primaryButton.background,
          })}
        />

        <PrimaryButton
          fullWidth
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "20px",
            color: theme.palette.mainFont.primary,
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#fff",
            },
            border: "0.829px solid #2E2E2E",
          })}
          onClick={handleToOcpp}
          text={"Zurück zur OCPP URL"}
        />
      </Stack>
    </Stack>
  );
};

export default OnboardingSlider;
